function getWrapper(editor) {
    const document = editor.document;
    const wrapper = document.findOne('body > div[data-vertical-text]');

    return wrapper;
}

function isVerticalWrapped(editor) {
    return Boolean(getWrapper(editor));
}

function wrapVertical(editor) {
    const document = editor.document;
    const body = document.getBody();

    const allContents = Array.from(body.getChildren().$);
    const wrapper = document.createElement('div', {
        styles: {
            width: '100%',
            height: '100%',
            'writing-mode': 'vertical-rl',
            'text-orientation': 'mixed'
        },
        attributes: {
            'data-vertical-text': true
        }
    });

    allContents.forEach(block => wrapper.append(new CKEDITOR.dom.node(block)));
    body.append(wrapper);
}

function unwrapVertical(editor) {
    const wrapper = getWrapper(editor);

    if (wrapper) {
        wrapper.remove(true);
    }
}

const command = {
    exec: function (editor, verticalText) {
        const prevVerticalText = isVerticalWrapped(editor);

        if (verticalText !== prevVerticalText) {
            if (verticalText) {
                wrapVertical(editor);
                this.setState(CKEDITOR.TRISTATE_ON);
            } else {
                unwrapVertical(editor);
                this.setState(CKEDITOR.TRISTATE_OFF);
            }
        }
    }
};

function updateState(editor) {
    editor.getCommand('verticalText').setState(
        isVerticalWrapped(editor) ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF
    );
}

function init(editor) {
    editor.addCommand('verticalText', command);
    editor.on('focus', () => updateState(editor, 'focus'));
}

export default {
    init
};
